/**
 * [임시 디버깅용] /mer/ 라우터 탐색 원인 추적 플러그인
 * - enforce: 'pre'로 최대한 이른 시점에 실행
 * - runtimeConfig.app.baseURL 확인 → 혹시 /mer/ 로 설정되어있는지 확인
 * - <base> 태그, window.location, __NUXT__ payload 등 핵심 환경 정보 출력
 * - 원인 파악 후 반드시 삭제할 것
 */
export default defineNuxtPlugin({
  name: 'debug-mer',
  enforce: 'pre',
  setup() {
    const router = useRouter()
    const runtimeConfig = useRuntimeConfig()

    // ★ 핵심: 런타임 baseURL 확인 (이 값이 /mer/이면 원인 확정)
    console.log('[DEBUG] ===== /mer/ 원인 추적 =====')
    console.log('[DEBUG] runtimeConfig.app.baseURL:', runtimeConfig.app.baseURL)
    console.log('[DEBUG] runtimeConfig.app.buildAssetsDir:', runtimeConfig.app.buildAssetsDir)
    console.log('[DEBUG] window.location.href:', window.location.href)
    console.log('[DEBUG] window.location.pathname:', window.location.pathname)

    // <base> 태그 확인
    const baseEl = document.querySelector('base')
    console.log('[DEBUG] <base> tag href:', baseEl?.getAttribute('href') ?? '(없음)')

    // __NUXT__ payload 확인
    console.log('[DEBUG] __NUXT__.config:', (window as any).__NUXT__?.config)

    // 라우터의 history base 확인
    console.log('[DEBUG] router.options.history.base:', (router.options.history as any)?.base)

    // 현재 라우터 상태 출력
    console.log('[DEBUG] currentRoute.fullPath:', router.currentRoute.value.fullPath)
    console.log('[DEBUG] =============================')

    // 모든 내비게이션을 로깅 (최초 /mer/ 진입 경로 추적)
    router.beforeEach((to, from) => {
      console.log(`[DEBUG-ROUTE] ${from.fullPath} → ${to.fullPath}`)
      if (to.path.startsWith('/mer')) {
        console.trace('[DEBUG] /mer/ 최초 진입 감지:', to.fullPath, '← from:', from.fullPath)
      }
    })

    // afterEach로도 잡아봄 (beforeEach에서 못 잡는 경우 대비)
    router.afterEach((to, from) => {
      if (to.path.startsWith('/mer')) {
        console.trace('[DEBUG-AFTER] /mer/ afterEach:', to.fullPath, '← from:', from.fullPath)
      }
    })
  }
})
